import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type IntegrationStatusValue = "connected" | "not_configured" | "coming_soon";

export type DealSyncHealth = {
  lastRunAt: string | null;
  lastRunOk: boolean | null;
  lastRunRows: number | null;
  recentErrorCount: number;
  dealsLastPulledAt: string | null;
};

export type EmailTransportStatus = {
  provider: "gmail";
  configured: boolean;
  from: string;
};

export type IntegrationsStatusResponse = {
  hubspot: {
    status: IntegrationStatusValue;
    portalId: string | null;
    partnerObjectTypeId: string | null;
    partnersCount: number;
    lastPartnerUpdatedAt: string | null;
    sync: DealSyncHealth;
  };
  email: { appTransport: EmailTransportStatus };
  slack: { status: IntegrationStatusValue };
  crossbeam: { status: IntegrationStatusValue };
  teams: { status: IntegrationStatusValue };
  mcp: { status: IntegrationStatusValue };
  powerbi: { status: IntegrationStatusValue };
};

// GET /api/settings/integrations/status — env-driven connection states for
// the integrations directory. Keys here mirror the provider list the
// legacy /app/admin/settings/integrations/page.tsx rendered inline; the
// SPA no longer has direct env access so the worker resolves them.
export function useIntegrationsStatus() {
  return useQuery<IntegrationsStatusResponse, ApiClientError>({
    queryKey: [...queryKeys.settings.integrations(), "status"] as const,
    queryFn: () =>
      apiFetch<IntegrationsStatusResponse>("/settings/integrations/status"),
  });
}
